import React from "react";

const PayrollNormalization = ({ row }) => {
  return <div>{row?.totalPayrolls?.toLocaleString()}</div>;
};

export default PayrollNormalization;
